module.exports = __webpack_public_path__ + "static/media/mooniswap.d7780b6d.svg";